module.exports = "../fonts/iconfont.svg?244c39c3cd11622dc0e69ff5b9a93e3f";